/*
CSS Browser Selector js v0.5.3 (July 2, 2013)

-- original --
Rafael Lima (http://rafael.adm.br)
http://rafael.adm.br/css_browser_selector
  License: http://creativecommons.org/licenses/by/2.5/
    Contributors: http://rafael.adm.br/css_browser_selector#contributors
      -- /original --

Fork project: http://code.google.com/p/css-browser-selector/
  Song Hyo-Jin (shj at xenosi.de)
*/
function css_browser_selector(u) {
  var ua = u.toLowerCase(),
    is = function(t) {
      return ua.indexOf(t) > -1
    },
    g = 'gecko',
    w = 'webkit',
    s = 'safari',
    c = 'chrome',
    o = 'opera',
    m = 'mobile',
    v = 0,
    r = window.devicePixelRatio ? (window.devicePixelRatio + '').replace('.', '_') : '1';
  var res = [
    /* IE */
    (!(/opera|webtv/.test(ua)) && /msie\s(\d+)/.test(ua) && (v = RegExp.$1 * 1)) ?
      ('ie ie' + v + ((v == 6 || v == 7) ?
        ' ie67 ie678 ie6789' : (v == 8) ?
          ' ie678 ie6789' : (v == 9) ?
            ' ie6789 ie9m' : (v > 9 ) ?
              ' ie9m' : '')) :
      /* IE 11 */
      (/trident\/\d+.*?;\s*rv:(\d+)\.(\d+)\)/.test(ua) && (v = [RegExp.$1, RegExp.$2])) ?
        'ie ie' + v[0] + ' ie' + v[0] + '_' + v[1] + ' ie9m' :
        /* FF */
        (/firefox\/(\d+)\.(\d+)/.test(ua) && (re = RegExp)) ?
          g + ' firefox firefox' + re.$1 + ' firefox' + re.$1 + '_' + re.$2 :
          is('gecko/') ? g :
            /* Opera */
            is(o) ? o + (/version\/(\d+)/.test(ua) ? ' ' + o + RegExp.$1 :
              (/opera(\s|\/)(\d+)/.test(ua) ? ' ' + o + RegExp.$2 : '')) :
              /* K */
              is('konqueror') ? 'konqueror' :
                /* Black Berry */
                is('blackberry') ? m + ' blackberry' :
                  /* Chrome */
                  (is(c) || is('crios')) ? w + ' ' + c :
                    /* Iron */
                    is('iron') ? w + ' iron' :
                      /* Safari */
                      !is('cpu os') && is('applewebkit/') ? w + ' ' + s :
                        /* Mozilla */
                        is('mozilla/') ? g : '',
    /* Android */
    is('android') ? m + ' android' : '',
    /* Tablet */
    is('tablet') ? 'tablet' : '',
    /* Machine */
    is('j2me') ? m + ' j2me' :
      is('ipad; u; cpu os') ? m + ' chrome android tablet' :
        is('ipad;u;cpu os') ? m + ' chromedef android tablet' :
          is('iphone') ? m + ' ios iphone' :
            is('ipod') ? m + ' ios ipod' :
              is('ipad') ? m + ' ios ipad tablet' :
                is('mac') ? 'mac' :
                  is('darwin') ? 'mac' :
                    is('webtv') ? 'webtv' :
                      is('win') ? 'win' + (is('windows nt 6.0') ? ' vista' : '') :
                        is('freebsd') ? 'freebsd' :
                          (is('x11') || is('linux')) ? 'linux' : '',
    /* Ratio (Retina) */
    (r != '1') ? ' retina ratio' + r : '',
    'js portrait'].join(' ');
  if(window.jQuery && !window.jQuery.browser) {
    window.jQuery.browser = v ? {msie: 1, version: v} : {};
  }
  document.documentElement.className += ' ' + res;
};
css_browser_selector(navigator.userAgent);


/* str_replace (faiq agayev[faiqagayev.com])*/
(function(window,$,undefined){
	window.str_replace = function($search,$replace,str)
	{
		if($search===undefined || $replace===undefined)return '';

		if(typeof($search)=='object' && typeof($replace)=='object')
			for(i=0;i<$search.length;i++)
				str = str_replace($search[i],$replace[i],str);

		else if(typeof($search)=='object')
			for(i=0;i<$search.length;i++)
				str = str_replace($search[i],$replace,str);

		else //while(str.indexOf($search)!=-1)
			str=str.toString().replace(new RegExp($search,'gi'),$replace);

		return str;
	}
	if(String.prototype.str_replace==null)String.prototype.str_replace = function($search,$replace)
	{
		return str_replace($search,$replace,this);
	}
	$.extend({
		str_replace : function($search,$replace,$str) {
			return str_replace($search,$replace,$str);
		}
	});
	$.fn.str_replace = function($search,$replace)
	{
		$(this).val(str_replace($search,$replace,$(this).val()));
	};
})(window,jQuery);
/* str_replace end*/

$(document).ready(()=>{

  //tabs
  $('body').on('click','.tabs[data-target] > *:not(.active)',function(e){
    e.preventDefault();
    const tab_parent =  $(this).closest('.tabs'),
      target = tab_parent.attr('data-target');
    if(tab_parent.length > 0 && target){

      const tab = $(this),
        tabs = tab_parent.find('>*'),
        index = tabs.index(tab),
        content = $(target).find('>*');

      tabs.removeClass('active');
      content.removeClass('active');

      tab.addClass('active');
      content.eq(index).addClass('active');
    }
  });


  $("form.validation").validationEngine({
    showPrompts:false,
    addFailureCssClassToField:"error"
  });

  $('[data-mask]').each(function(){
    const type = $(this).data('mask');
    switch (type){
      case "phone":
        $(this).inputmask({
            showMaskOnHover:false,
          mask: "(*) 999 - 99 - 99",
          definitions: {
            '9': {
              validator: "[0-9]",
              cardinality: 1,
              casing: "lower"
            },
            '*':{
              validator:"(10|50|51|55|60|70|77|99)",
              cardinality: 2,
            }
          }
        });
        break;
      case "number":
      case "decimal":
      case "integer":
        $(this).inputmask(type, { rightAlign: false });
        break
    }
  });

  $('[data-match-height]').each(function () {
    $(this).find($(this).attr('data-match-height')).matchHeight();
  });

	if($('.partner_carousel').length>0){
		$('.partner_carousel .owl-carousel').owlCarousel({
			margin:0,
			responsiveClass:true,
			nav:true,
			dots:false,
			navText:['',''],
			responsive:{
				0:{
					items:1,
				},
				550:{
					items:3,
				},
				767:{
					items:4,
				},
				991:{
					items:6,
				}
			}
		});
	}
	if($('.projects').length>0){
		$(document).on('mobile_on',function(){
			const container = $('.projects .items');
			if (container.hasClass("owl-carousel")) return;
			container.addClass('owl-carousel').owlCarousel({
				margin:0,
				responsiveClass:true,
				nav:true,
				dots:false,
				navText:['',''],
				responsive:{
					0:{
						items:1,
					}
				}
			});
		})
			.on('mobile_off',()=>{
				const container = $('.projects .items');
				if (!container.hasClass("owl-carousel")) return;
				container.owlCarousel({
					touchDrag: false,
					mouseDrag: false
				});
				container.trigger('destroy.owl.carousel').removeClass('owl-carousel owl-loaded');
				container.find('.owl-stage-outer').children().unwrap();
				container.removeData();
			});
	}

	$('.open_mobile_menu').click(function(){
		$('#header nav').addClass('open');
	});
	$('.close_mobile_menu').click(function(){
		$('#header nav').removeClass('open');
	});

	$('#header .search .toggle').on('click', function(){
		$('#search_popup').addClass('open');
		setTimeout(() => $('#search_popup').addClass('animate'), 10);
	});
	$('#search_popup .back').on('click', function(){
		$('#search_popup').removeClass('animate');
		setTimeout(() => $('#search_popup').removeClass('open'), 400);
	});

	if($('[data-body-class]').length>0){
		$('body').addClass($('[data-body-class]:first').attr('data-body-class'));
	}

	if($('.news_detail_page .owl-carousel').length>0){
		$('.news_detail_page .owl-carousel').owlCarousel({
			margin:20,
			responsiveClass:true,
			nav:true,
			dots:false,
			navText:['',''],
			responsive:{
				0:{
					items:2,
				},
				550:{
					items:4,
				},
			}
		});
	}
	if($('.projects_page .owl-carousel').length>0){
		$('.projects_page .owl-carousel').owlCarousel({
			margin:20,
			responsiveClass:true,
			nav:true,
			dots:false,
			navText:['',''],
			responsive:{
				0:{
					items:2,
				},
				550:{
					items:3,
				},
			}
		});
	}

	$('#search_popup .submit').on('click',function(e){
		e.preventDefault();
		if($('#search_popup input[name="q"]').val().length>2){
			let url = $('#search_popup input[name="q"]').closest('form').attr('action') + $('#search_popup input[name="q"]').val();
			$('#search_popup .search_result').html('<div class="loading"><div class="lds-grid"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div>');
			$.get(url,function (html) {
				$('#search_popup .search_result').html(html);
			});
		}
	});

	if($('.faq_page').length){
		$('.faq_page .item h3').click(function(){
			var item = $(this).parent();
			if(item.hasClass('open'))item.removeClass('open');
			else item.addClass('open');
		});
	}

	const media = window.matchMedia("(max-width: 991px)");
	mobileSupport(media);
	media.addListener(mobileSupport);
});

$.is_mobile = false;
const mobileSupport = media => {
  if (media.matches){
    $.is_mobile = true;

		$('body').on('click','#header nav li:has(ul) > a',function(e){
			e.preventDefault();
			var li = $(this).parent();
			if(li.hasClass('active'))li.find('ul').animate({height:0},500,function(){ li.removeClass('active'); });
			else {
				li.addClass('active');

				li.find('ul').animate({height:li.find('li').length*li.find('li').first().outerHeight()},500);
			}
		});

		$('.social').insertAfter('.close_mobile_menu');
		$('#header .lang').insertAfter('#header h1');
		$('#header .search').insertAfter('#header h1');

		if($('.tenders_page .tr:not(.header)').length>0){
			const th = $('.tenders_page .header > div');
			$('.tenders_page .tr:not(.header)').each(function(){
				const tr = $(this).find('>div');
				tr.each(function(index,elem){
					$('<b class="mobile_label">'+str_replace(':','',th.eq(index).html())+' :</b>').prependTo(elem);
				});
			});
		}


    $(document).trigger('mobile_on');
  }
  else{
    $.is_mobile = false;
		$('#header .search').appendTo('#header .top .right');
		$('.social').insertAfter('#header .search');
		$('#header .lang').insertAfter('#header .social');

		$('body').off('click','#header nav li:has(ul) > a');

		if($('.tenders_page .tr:not(.header)').length>0){
			$('.tenders_page .datatable .mobile_label').remove();
		}

    $(document).trigger('mobile_off');
  }
};